module.exports = __webpack_public_path__ + "img/badge-most-proposals-gold.e923ace6.png";